const setSizeVariants = (gender, productType, node_locale) => {
  let sizeVariants
  switch (gender.name) {
    case 'Men':
      if (productType.menSizesV2) {
        sizeVariants = productType.menSizesV2
      }
      break
    case 'Women':
      if (productType.womenSizesV2) {
        sizeVariants = productType.womenSizesV2
      }
      break
    case 'Unisex':
      if (productType.unisexSizesV2) {
        sizeVariants = productType.unisexSizesV2
      }
      break
  }

  // ankle size
  const minAnkleSizeValue =
    sizeVariants &&
    sizeVariants[0].ankleRanges &&
    sizeVariants
      .map((variant) => variant.ankleRanges.map((range) => range.minValue))
      .reduce((acc, cur) => acc.concat(cur))
      .reduce((acc, cur) => (acc < cur ? acc : cur))
  const maxAnkleSizeValue =
    sizeVariants &&
    sizeVariants[0].ankleRanges &&
    sizeVariants
      .map((variant) => variant.ankleRanges.map((range) => range.maxValue))
      .reduce((acc, cur) => acc.concat(cur))
      .reduce((acc, cur) => (acc > cur ? acc : cur))
  const defaultAnkleSizeValue = Math.floor(
    (minAnkleSizeValue + maxAnkleSizeValue) / 2,
  )
  // calf range
  const defaultCalfRange =
    sizeVariants &&
    sizeVariants[0].calfRanges &&
    sizeVariants[0].calfRanges[0].measurementName
  // lower leg range
  const defaultLowerLegRange =
    sizeVariants &&
    sizeVariants[0].lowerLegRanges &&
    sizeVariants[0].lowerLegRanges[0].measurementName
  // shoe size
  const minShoeSizeValue =
    sizeVariants &&
    sizeVariants[0].shoeRanges &&
    sizeVariants
      .map((variant) =>
        variant.shoeRanges.map((range) => {
          switch (node_locale) {
            case 'en-GB':
              return range.minValueUk
            case 'en-US':
              return range.minValueUs
            default:
              return range.minValue
          }
        }),
      )
      .reduce((acc, cur) => acc.concat(cur))
      .reduce((acc, cur) => (acc < cur ? acc : cur))
  const maxShoeSizeValue =
    sizeVariants &&
    sizeVariants[0].shoeRanges &&
    sizeVariants
      .map((variant) =>
        variant.shoeRanges.map((range) => {
          switch (node_locale) {
            case 'en-GB':
              return range.maxValueUk
            case 'en-US':
              return range.maxValueUs
            default:
              return range.maxValue
          }
        }),
      )
      .reduce((acc, cur) => acc.concat(cur))
      .reduce((acc, cur) => (acc > cur ? acc : cur))
  const defaultShoeSizeValue = Math.floor(
    (minShoeSizeValue + maxShoeSizeValue) / 2,
  )

  return {
    sizeVariants,
    minAnkleSizeValue,
    maxAnkleSizeValue,
    defaultAnkleSizeValue,
    defaultCalfRange,
    defaultLowerLegRange,
    minShoeSizeValue,
    maxShoeSizeValue,
    defaultShoeSizeValue,
  }
}

export default setSizeVariants
